import React from 'react';
import PropTypes from 'prop-types';

export default class TourPicture extends React.Component {
  static displayName = 'TourPicture';

  static propTypes = {
    pictureUrl: PropTypes.string,
    defaultFor: PropTypes.string,
  };

  static defaultProps = {
    pictureUrl: null,
    defaultFor: null,
  };

  _picture() {
    let picture = this.props.pictureUrl;

    if (!this.props.pictureUrl) {
      switch (this.props.defaultFor) {
        case 'tour':
          picture = require('./custom_tour_default.jpg');
          break;
        case 'invoice':
        default:
          picture = require('./invoice_default.jpg');
          break;
      }
    }

    return picture;
  }

  render() {
    let src = this._picture();
    return <img className="tour-picture" src={src} alt="Tour" />;
  }
}
